// services/doctor.ts
import { AuthFetch } from "../hooks/useApi";
import { Doctor } from "../types/auth.types"
import { DoctorUpdateRequest, DoctorUpdateResponse } from "../types/doctors.types"
import { SecretaryUpsertPayload, SecretaryUpsertResponse, SecretaryDeleteResponse, SecretaryListResponse } from "../types/secretary.types"

export const doctorService = {

  update: (
    apiFetch: AuthFetch,
    email: string,
    payload: DoctorUpdateRequest,
  ): Promise<DoctorUpdateResponse> =>
    apiFetch<DoctorUpdateResponse>(`/doctors/${email}`, {
      method: "PUT",
      body:   JSON.stringify(payload),
    }),

  get: (
    apiFetch: AuthFetch,
    email: string,
  ): Promise<Doctor | null> =>
    apiFetch<Doctor | null>(`/doctors/${email}`, {
      method: "GET",
    }),

  // `post` (criação de médico via POST /doctors/) foi removido — a criação
  // de organização/perfil inicial agora passa por onboardingService.post
  // (POST /onboarding), ver src/services/onboarding.ts.

  addSecretaries: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    payload: SecretaryUpsertPayload,
  ): Promise<SecretaryUpsertResponse> =>
    apiFetch<SecretaryUpsertResponse>(`/doctors/${doctorEmail}/secretaries`, {
      method: "POST",
      body:   JSON.stringify(payload),
    }),

  deleteSecretary: (
    apiFetch: AuthFetch,
    doctorEmail: string,
    secretaryEmail: string,
  ): Promise<SecretaryDeleteResponse> =>
    apiFetch<SecretaryDeleteResponse>(`/doctors/${doctorEmail}/secretaries/${secretaryEmail}`, {
      method: "DELETE",
    }),

  listSecretaries: (
    apiFetch: AuthFetch,
    doctorEmail: string,
  ): Promise<SecretaryListResponse> =>
    apiFetch<SecretaryListResponse>(`/doctors/${doctorEmail}/secretaries`, {
      method: "GET",
    }),
};